import $ from 'jquery';
import 'slick-carousel';

import accordion from './accordion';
import slider from './slider';
import scroll from './scroll';

$(() => {
  accordion();
  slider();
  scroll();
});